var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"describe"},[_vm._t("month"),_vm._t("date"),_vm._t("day"),_vm._t("recent")],2)}
var staticRenderFns = []

export { render, staticRenderFns }